import { Scope, StyleAttributor } from 'parchment';
export const DisplayStyle = new StyleAttributor('display', 'display', {
    scope: Scope.INLINE,
    whitelist: ['inline', 'inline-block', 'block'],
});
